import { User } from '../contexts/UserContext';

export function usuarioEhCorrespondente(user: User | undefined): boolean {
    return user?.profile === 'comum';
}

export function usuarioEhSolicitante(user: User | undefined): boolean {
    return user?.profile === 'Solicitante';
}

export function usuarioNaoPodeVerContato(user: User | undefined): boolean {
    return usuarioEhCorrespondente(user) || usuarioEhSolicitante(user);
}

export function podeEditarDemanda(user: User | undefined): boolean {
    return user?.profile === 'operador' || user?.profile === 'admin';
}

